<template>
    <div class="quote-message" @click="gotoReply">
        <div class="author">
            {{ getAuthor() }}
        </div>
        <div class="image" v-if="isImageMessage()">
            <viewer :id="'imageViewer-' + getId()" :images="[fileSrc()]" v-if="fileSrc()">
                <div
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('chatbotv2.imageView')"
                    class="cb-img-preview"
                    @click="showImage()"
                >
                    <img
                        :id="'img-' + getId()"
                        :src="fileSrc()"
                        class="img-thumbnail ant-upload-list-picture-card-container"
                        style="object-fit: cover"
                    />
                    <md-icon v-if="imageHovered" class="cb-pr-icon"> visibility</md-icon>
                </div>
            </viewer>
        </div>
        <div class="file" v-if="isFileMessage()">
            <div class="media-content-wrapper">
                <a
                    :href="fileSrc()"
                    download
                    target="_blank"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    content="Dosyayı indir"
                >
                    <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                        <div class="fi-content">{{ getExt() }}</div>
                    </div>
                    <a-icon type="cloud-download" v-else />
                    <p class="asset-text">{{ getAssetName() }}</p>
                </a>
            </div>
        </div>
        <div class="text" v-else v-html="getText()" />
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import $_ from "lodash";
import { toNewMessagesModel } from "../../utils/chat";
import { mapGetters } from "vuex";

export default Vue.extend({
    name: "QuoteMessage",
    props: ["message"],
    computed: {
        ...mapGetters({
            getUser: "user/getUser",
        }),
    },
    data() {
        return {
            imageHovered: false,
            previewImg: false,
        };
    },
    methods: {
        isAudioMessage() {
            const model = toNewMessagesModel([this.message], this)[0];
            const isAudioType = model.type === "audio";
            const isAudioMime = _.get(model, "raw.asset.mime", "").includes("audio");
            return isAudioType || isAudioMime;
        },
        isVideoMessage() {
            const model = toNewMessagesModel([this.message], this)[0];
            const isVideoType = model.type === "video";
            const isVideoMime = _.get(model, "raw.asset.mime", "").includes("video");
            return isVideoType || isVideoMime;
        },
        isImageMessage() {
            const model = toNewMessagesModel([this.message], this)[0];
            const isImageType = model.type === "image";
            const isImageMime = _.get(model, "raw.asset.mime", "").includes("image");
            return isImageType || isImageMime;
        },
        isFileMessage() {
            const model = toNewMessagesModel([this.message], this)[0];
            const assetExists = !!model.raw?.asset;
            return !this.isAudioMessage() && !this.isVideoMessage() && !this.isImageMessage() && assetExists;
        },
        getExt() {
            const model = toNewMessagesModel([this.message], this)[0];

            return model.raw?.asset?.ext || "";
        },
        getAssetName() {
            const model = toNewMessagesModel([this.message], this)[0];
            const assetName = model?.raw?.asset?.name || "Dosyayı indir";
            return assetName;
        },
        fileSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.asset;
            }
            const path = asset?.path || "";
            if (path === "") return null;
            const isWhatsapp = path.indexOf("whatsapp") !== -1;
            const isInstagram = path.indexOf("instagram") !== -1;
            const isMessenger = path.indexOf("messenger") !== -1;
            const isTelegram = path.indexOf("telegram") !== -1;
            const isLinkedin = path.indexOf("linkedin") !== -1;

            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger || isLinkedin
                    ? `https://static.supsis.live/${path}`
                    : asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    :`https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
        getId() {
            let id = "";
            if (!!this.message.isMail) {
                id = "img-" + this.message._id;
            } else {
                id = "img-" + this.message.asset._id;
            }
            return id;
        },
        showImage() {
            const id = this.getId();
            const prefixedId = "img-" + id;
            document.getElementById(prefixedId).click();
        },
        gotoReply() {
            if (this.isImageMessage()) {
                this.showImage();
                return;
            }
            let messageElement = document.getElementById(`sc-message_${this.message._id}`);
            if (!messageElement) messageElement = document.getElementById(`sc-message_${this.message.uniqMessageId}`);
            if (messageElement)
                messageElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                });
        },
        getText() {
            if (this.isAudioMessage()) {
                return "Ses kaydı";
            } else if (this.isVideoMessage()) {
                return "Video";
            } else if (this.isImageMessage()) {
                return "Görüntü";
            } else {
                let message = this.message?.message || this.message?.description || "";
                // log.debug("message", message, message.trim, this.message);
                message = message.trim();
                let escaped = htmlUnescape(message);

                let res = Autolinker.link(escaped, {
                    className: "chatLink",
                    truncate: { length: 50, location: "smart" },
                });
                res = this.fillLinkTargetBlank(res);
                res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
                return res;
            }
        },
        fillLinkTargetBlank(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
        getAuthor() {
            const model = toNewMessagesModel([this.message], this)[0];
            return this.message?.conversation?.fullname || model.author;
        },
    },
});
</script>

<style scoped lang="scss">
@import "~css-file-icons";

.quote-message {
    background: var(--color-bg-neutral-default);
    padding: 5px;
    margin: 3px;
    border-radius: 5px;
    border-left: 4px solid #ffa800;

    min-width: 300px;
    display: flex;
    flex-direction: column;

    .author {
        color: #ffa800;
        font-size: 13px;
        font-width: 600;
    }

    .text {
        color: #1e1e2da6;
        font-size: 12px;
    }

    .image {
        .cb-pr-icon {
            position: absolute;
            pointer-events: none;
        }

        .cb-img-preview {
            max-width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;

            .cb-pr-icon {
                z-index: 2;
            }
        }

        .cb-img-preview:hover {
            cursor: pointer;
            filter: grayscale(100%);
        }

        .image-message-img {
            margin: 18px 6px;
            border-radius: 6px;
        }
    }

    .file {
        .media-content-wrapper {
            margin: 4px;

            a {
                display: flex;
                gap: 5px;
                flex-direction: row;
                align-items: center;
                padding: 5px;

                &:hover {
                    p {
                        border-bottom: 1px solid #000;
                    }
                }

                p {
                    border-bottom: 1px solid transparent;
                    margin-bottom: 0;
                }
            }

            .asset-text {
                color: var(--color-text-info-default) !important;
            }

            .media-content-text {
                margin-bottom: 0;
                font-family: Poppins, monospace;
                margin-top: 6px;
                font-size: 12px;
                font-weight: 400;
                text-align: center;
            }
        }
    }
}
</style>
<style lang="scss">
.viewer-open {
    .viewer-container {
        z-index: 9999999 !important;
    }
}
</style>
